// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file___4_d3","fileBtn":"File_fileBtn__DNmHL","closeBtn":"File_closeBtn__2eIky","fileSelected":"File_fileSelected__Cj7YM","disabled":"File_disabled__2lKZY"};